<template lang="pug">
	.builder-step
		.header-data
			h3.content-block.header {{caption}}
			.proposal-buttons-group
				DxButton(v-if="showBack", text="Back", icon="chevrondoubleleft", @click="$emit('back')")
				DxButton(v-if="showCreateProposal", text="Create proposal", @click="$emit('create-proposal')", type="default")
				DxButton(v-if="showNext", text="Next", icon="chevrondoubleright", @click="$emit('next')")
		slot
		.proposal-buttons-group.bottom
			DxButton(v-if="showBack", text="Back", icon="chevrondoubleleft", @click="$emit('back')")
			DxButton(v-if="showCreateProposal", text="Create proposal", @click="$emit('create-proposal')", type="default")
			DxButton(v-if="showNext", text="Next", icon="chevrondoubleright", @click="$emit('next')")
</template>

<script>
	import VueTypes from 'vue-types';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'proposal.BuilderStep',
		name: 'builder-step',
		components: {
			DxButton
		},
		props: {
			showBack: VueTypes.bool.def(true),
			showCreateProposal: VueTypes.bool.def(true),
			showNext: VueTypes.bool.def(true),
			caption: VueTypes.string.def(null)
		}
	};
</script>
<style lang='scss'>
	.builder-step {
		h3 {
			font-size: 22px;
		}

		.proposal-buttons-group.bottom {
			padding: 20px;
		}
	}
</style>
